import { PropsWithChildren } from "react";

import { listItemTextClasses, ListItemTextVariants } from "./List.style";
import Typography from "@/Typography/Typography";
import Box from "@/Box";
import { TypographyProps } from "@/Typography/useTypography";

export type ListItemTextProps = {
  className?: string;
  primary?: string;
  secondary?: string;
} & ListItemTextVariants &
  Pick<TypographyProps, "variant">;

export function ListItemText(props: PropsWithChildren<ListItemTextProps>) {
  const { children, variant, className, primary, secondary, ...rest } = props;

  return (
    <Box
      className={listItemTextClasses({
        class: className,
      })}
      {...rest}
    >
      {primary && (
        <Typography
          render={<span />}
          variant="body2"
          className="block font-semi-bold tracking-wide"
        >
          {primary}
        </Typography>
      )}
      {secondary && (
        <Typography render={<span />} variant="body1" className="text-gray-600">
          {secondary}
        </Typography>
      )}
      {children}
    </Box>
  );
}

export default ListItemText;
